import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { GlobalSearch } from './global-search.model';
import { DocumentsSearch } from './document-search.model';
import {
  getDocumentsFetched,
  getDocumentsSearch,
  getError,
  getGlobalFetched,
  getGlobalSearch,
  getGlobalSearchParams,
  getRecentDocuments,
  getRecentDocumentsFetched,
} from './search-data.reducer';
import { RecentDocumentsSearch } from './recent-documents-search.model';
import { ISearchParams } from './search-data.data';

@Injectable()
export class SearchDataStore {
  constructor(private _store: Store<any>) {}

  getGlobalSearch(): Observable<GlobalSearch> {
    return this._store.select(getGlobalSearch);
  }

  getGlobalSearchParams(): Observable<ISearchParams> {
    return this._store.select(getGlobalSearchParams);
  }

  getDocumentsSearch(): Observable<DocumentsSearch> {
    return this._store.select(getDocumentsSearch);
  }

  getRecentDocuments(): Observable<RecentDocumentsSearch> {
    return this._store.select(getRecentDocuments);
  }

  getGlobalFetched(): Observable<boolean> {
    return this._store.select(getGlobalFetched);
  }

  getDocumentsFetched(): Observable<boolean> {
    return this._store.select(getDocumentsFetched);
  }

  getRecentDocumentsFetched(): Observable<boolean> {
    return this._store.select(getRecentDocumentsFetched);
  }

  getError(): Observable<any[]> {
    return this._store.select(getError);
  }
}
